/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Month_No_EventsInputs */



/**
* | output |
* | --- |
* | "No recorded events" |
*
* @param {Partner_Admin_Commission_Month_No_EventsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_month_no_events = /** @type {((inputs?: Partner_Admin_Commission_Month_No_EventsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Month_No_EventsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine erfassten Ereignisse")
	return /** @type {LocalizedString} */ ("No recorded events")
});